import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SiteApiEffects } from './site-api.effects';
import { siteReducer } from './site.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature('site', siteReducer), EffectsModule.forFeature([SiteApiEffects])],
})
export class SiteModule {}
